import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Head from '../../../components/Partials/Head/Head';
import Auxiliary from '../../../hoc/Auxiliary';
import ServiceBanner from '../../../components/ServiceBanner/ServiceBanner';
import satelliteIcon from '../../../components/Satellites/satelliteIcon';
import satelliteLinks from '../../../components/Satellites/satelliteLinks';
import InternalVsExternalSupport2 from '../../../components/Satellites/itSupport/InternalVsExternalSupport/InternalVsExternalSupport2/InternalVsExternalSupport2';
import InternalVsExternalSupport3 from '../../../components/Satellites/itSupport/InternalVsExternalSupport/InternalVsExternalSupport3/InternalVsExternalSupport3';
import InternalVsExternalSupport4 from '../../../components/Satellites/itSupport/InternalVsExternalSupport/InternalVsExternalSupport4/InternalVsExternalSupport4';
import InternalVsExternalSupport5 from '../../../components/Satellites/itSupport/InternalVsExternalSupport/InternalVsExternalSupport5/InternalVsExternalSupport5';
import InternalVsExternalSupport6 from '../../../components/Satellites/itSupport/InternalVsExternalSupport/InternalVsExternalSupport6/InternalVsExternalSupport6';
import InternalVsExternalSupport7 from '../../../components/Satellites/itSupport/InternalVsExternalSupport/InternalVsExternalSupport7/InternalVsExternalSupport7';

class InternalVsExternalSupport extends Component {
  render() {
    return (
      <Auxiliary>
        <Head {...this.props} id="internal_vs_external_support" />
        <ServiceBanner {...this.props} page="internalVsExternalSupport" icon={satelliteIcon} textComponents={satelliteLinks(this.props.t)} />
        <InternalVsExternalSupport2 {...this.props} />
        <InternalVsExternalSupport3 {...this.props} />
        <InternalVsExternalSupport4 {...this.props} />
        <InternalVsExternalSupport5 {...this.props} />
        <InternalVsExternalSupport6 {...this.props} />
        <InternalVsExternalSupport7 {...this.props} />
      </Auxiliary>
    )
  }
}
export default withTranslation()(InternalVsExternalSupport);
